import { useEffect, useState } from 'react'
import { useAppDispatch } from '../../reducers/store'
import { fetchForensicsForDevice, selectDevices } from '../../reducers/devices'
import { useSelector } from 'react-redux'
import PageSkeleton from '../skeleton/PageSkeleton'
import { useParams } from 'react-router-dom'
import { MagnifyingGlassIcon } from '@radix-ui/react-icons'
import ForensicTreeTable from '../data-grid/ForensicTreeTable'
import { DeviceForensic } from '../../types/DeviceForensicTypes'

interface IDeviceOverviewEventsProps {
  setPopoutData: (data: DeviceForensic) => void
  setShowPopout: (show: boolean) => void
}

function DeviceOverviewForensics(props: IDeviceOverviewEventsProps) {
  const { setPopoutData, setShowPopout } = props

  const di = useAppDispatch()
  const { deviceId } = useParams()
  const { deviceForensics } = useSelector(selectDevices)
  const [dataLoading, setDataLoading] = useState<boolean>(true)
  const [expandedPaths, setExpandedPaths] = useState<Set<string>>(new Set())
  const [allPaths, setAllPaths] = useState<string[]>([])

  useEffect(() => {
    setDataLoading(true)
    di(fetchForensicsForDevice(deviceId!))
  }, [])

  useEffect(() => {
    if (deviceForensics && deviceForensics.deviceId === deviceId) {
      setDataLoading(false)
      const paths: string[] = []
      const traverse = (items: DeviceForensic[]) => {
        items.forEach((item) => {
          paths.push(item.path)
          if (item.children && item.children.length > 0) {
            traverse(item.children)
          }
        })
      }
      traverse(deviceForensics.forensics as DeviceForensic[])
      setAllPaths(paths)
    }
  }, [deviceForensics])

  return (
    <>
      {dataLoading ? (
        <div className="flex justify-center items-center min-h-screen">
          <PageSkeleton />
        </div>
      ) : (
        <>
          {deviceForensics == undefined || (deviceForensics && (deviceForensics.forensics as DeviceForensic[]).length === 0) ? (
            <div className="flex items-center justify-center h-full">
              <div className="text-center -mt-32">
                <div className="flex items-center justify-center">
                  <MagnifyingGlassIcon className="h-12 w-12" />
                </div>
                <p className="font-bold">No Forensic Data</p>
                <p className="text-sm">This device has no forensic data</p>
              </div>
            </div>
          ) : (
            <>
              <div className="mx-auto w-full pr-8 overflow-y-auto ">
                <div className="flex items-center px-4 py-2 pb-4 text-sm text-gray-500">
                  <button onClick={() => setExpandedPaths(new Set(allPaths))}>Expand All</button>
                  <span className="mx-2 pb-0.5">|</span>
                  <button onClick={() => setExpandedPaths(new Set())}>Collapse All</button>
                </div>
                <ForensicTreeTable
                  setShowPopout={setShowPopout}
                  setPopoutData={setPopoutData}
                  data={deviceForensics.forensics}
                  loading={dataLoading}
                  expanded={Array.from(expandedPaths)}
                  setExpanded={setExpandedPaths}
                />
              </div>
            </>
          )}
        </>
      )}
    </>
  )
}

export default DeviceOverviewForensics
